module.exports = __webpack_public_path__ + "static/media/workano-light-en.1901ec09.svg";